import { useState } from 'react'
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react'

/**
 * [L11 P2] Shown once right after a successful self-enroll: the durable personal return link the
 * canvasser saves so they can get back to THIS identity after their session lapses. Lives in
 * components/enroll/ (NOT the canvasser PII subtree) — copying a re-entry CREDENTIAL is not
 * walk-list PII export, so it is out of the noExport guard's scope by design.
 */
export function SaveReturnCard({ link, onContinue, campaignLabel }: { link: string; onContinue: () => void; campaignLabel?: string | null }) {
  const [copied, setCopied] = useState(false)
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link)
      setCopied(true)
    } catch {
      setCopied(false) // clipboard blocked (older browser / permissions) — the link text is still selectable
    }
  }
  return (
    <VStack py={12} px={6} gap={5} maxW="26rem" mx="auto" align="stretch">
      <Box>
        <Heading size="lg" mb={1}>You're in — save your way back</Heading>
        <Text color="fg.muted">
          Keep this link. If you're signed out later, open it on this phone to pick up where you left off.
        </Text>
      </Box>
      <Text
        fontFamily="mono"
        fontSize="sm"
        px={3}
        py={3}
        minH="44px"
        borderWidth="1px"
        borderRadius="md"
        wordBreak="break-all"
        userSelect="all"
      >
        {link}
      </Text>
      <Button variant="outline" minH="44px" onClick={copy}>{copied ? 'Copied' : 'Copy link'}</Button>
      <Button colorPalette="brand" minH="44px" onClick={onContinue}>
        {campaignLabel ? `Continue to ${campaignLabel}` : 'Continue'}
      </Button>
    </VStack>
  )
}
